export default {
  codeError: state => state.codeError,
  refreshToken: state => state.refreshToken,
  isShowModalMap: state => state.isShowModalMap
}
